import * as React from "react";

const Icon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="82" height="32" viewBox="0 0 82 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" width="22" height="6" rx="1" fill="#D9D9D9" />
    <rect x="55.5" width="26" height="6" rx="1" fill="#D9D9D9" />
    <path d="M30.5 6H53.5" stroke="#667080" strokeDasharray="2 2" />
    <path d="M52.5 19H81.5" stroke="#667080" strokeDasharray="2 2" />
    <rect x="0.5" y="13" width="46" height="6" rx="1" fill="#D9D9D9" />
    <rect x="1.5" y="26" width="80" height="6" rx="1" fill="#D9D9D9" />
  </svg>
);

export default Icon;
